/**
 * WordPress dependencies
 */

/**
 * Internal dependencies.
 */
import blockJson from './block.json';

/**
 * Block constants
 */
const { name } = blockJson;

export default {
	hookPrefix: name.replace( 'gutenify/', '' ),
};

